/**
 * localStorage / sessionStorage 缓存 key 枚举
 * 所有本地存储的 key 都应在此统一管理，避免硬编码
 */
export enum CacheEnum {
  // ========== 用户相关 ==========
  /** 用户 Token */
  token = 'USER_TOKEN',
  /** 用户 ID (cid) */
  userId = 'CID',
  /** 用户所在国家 */
  userCountry = 'COUNTRY',
  /** 用户信息 (zustand persist) */
  userInfoStorage = 'user-info',

  // ========== 主题与布局 ==========
  /** 颜色模式 (light/dark) */
  colorMode = 'COLOR_MODE',
  /** 侧边栏折叠状态 */
  siderCollapsed = 'SIDER_COLLAPSED',

  // ========== 菜单与导航 ==========
  /** 面包屑路由列表 */
  openRouteList = 'OPEN_ROUTER_LIST',
  /** 菜单展开的 keys */
  openMenu = 'MENU_OPEN_KEYS',
  /** 菜单选中的 keys */
  selectMenu = 'MENU_SELECT_KEYS',
  /** Header Tab 标签列表 */
  tabs = 'HEADER_TABS',

  // ========== UI 提示与引导 ==========
  /** 浏览器插件最后已读版本号 */
  extensionLastReadVersion = 'EXTENSION_LAST_READ_VERSION',
  /** 列设置引导是否已展示 */
  columnSettingGuideShown = 'COLUMN_SETTING_GUIDE_SHOWN',

  // ========== 表格配置 ==========
  /** SKU 表格列可见性配置 */
  followSkuTableColumns = 'FOLLOW_SKU_TABLE_COLUMNS_V2',

  // ========== 工具箱 ==========
  /** 工具箱状态 (zustand persist) */
  toolboxStorage = 'toolbox-storage',
}
